import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";

const highlights = [
  "Strengthen internal processes & operations",
  "Build a long-term development strategy",
  "Enhance team capacity with expert-led sessions",
  "Improve decision-making and planning",
  "Customized support based on your stage of growth",
];

const CapacityHighlights = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 text-center">
        {/* Program Title */}
        <motion.h2
          className="text-3xl md:text-4xl font-heading font-extrabold text-primary mb-12 tracking-tight"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          NGO Capacity Building Program
        </motion.h2>

        <p className="text-lg md:text-xl text-gray-600 mb-12 mx-auto max-w-3xl">
          Empowering Social Organizations for Long-Term Impact
          <br />
          Our program is designed to support grassroots organizations by
          strengthening leadership, building robust systems, and enhancing
          operational efficiency for meaningful impact.
        </p>

        {/* Highlights Section */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mt-6"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {highlights.map((point, i) => (
            <motion.div
              key={i}
              className="glass-card px-6 py-8 text-left flex items-start gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
            >
              <CheckCircle className="text-primary w-6 h-6 flex-shrink-0 mt-1" />
              <p className="text-gray-800 text-lg font-medium font-body">{point}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Custom styles for glassmorphism */}
        <style>{`
          .glass-card {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.85), rgba(237, 244, 255, 0.8));
            backdrop-filter: blur(14px) saturate(180%);
            border-radius: 1rem;
            border: 1.5px solid rgba(22, 167, 196, 0.2);
            box-shadow: 0 10px 25px rgba(0,0,0,0.05);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .glass-card:hover {
            transform: translateY(-6px) scale(1.02);
            box-shadow: 0 15px 36px rgba(0,0,0,0.1);
          }
        `}</style>
      </div>
    </section>
  );
};

export default CapacityHighlights;
